import { useState } from "react";
import { ChartsSection } from "./ChartsSection";
import { PerformanceSection } from "./PerformanceSection";
import { DailyProfitChart } from "./DailyProfitChart";
import { ProfitTrendsChart } from "./ProfitTrendsChart";

export default function TableDashboard({ dashboard, loading }) {
  const [activeTab, setActiveTab] = useState("history");
  const tabBaseStyle =
    "pb-2 cursor-pointer text-base focus:outline-none transition-all duration-150 ease-in-out";

  const activeTabSpecificStyle = "font-semibold border-b-2 border-black";

  const inactiveTabSpecificStyle =
    "font medium text-gray-500 hover:text-gray-700";

  return (
    <div className="flex flex-col bg-white rounded-xl p-6">
      <div className="flex space-x-8 z-10">
        <div
          className={`${tabBaseStyle}
            ${
              activeTab === "history"
                ? activeTabSpecificStyle
                : inactiveTabSpecificStyle
            }`}
          onClick={() => setActiveTab("history")}
        >
          Daily Profit
        </div>
        <div
          className={`${tabBaseStyle}
            ${
              activeTab === "botlog"
                ? activeTabSpecificStyle
                : inactiveTabSpecificStyle
            }`}
          onClick={() => setActiveTab("botlog")}
        >
          Profit Trends
        </div>
      </div>
      <div className="mt-8">
        {activeTab === "history" && <DailyProfitChart dashboard={dashboard} />}
        {activeTab === "botlog" && <ProfitTrendsChart dashboard={dashboard} />}
      </div>
    </div>
  );
}
